/**
 * The default date format to use within the app
 */
export const DATE_FORMAT = 'MM-dd-yyyy';

/**
 * This value should be used whenever we're sending a date format to the server
 * to be used by Java. Java's date format pattern is different from JavaScript's.
 */
export const JAVA_US_DATE_FORMAT = 'MM-dd-yyyy';

/**
 * The default time format to use within the app
 */
export const TIME_FORMAT = 'hh:mm aa';

/**
 * A format to match JavaScript's ```Date#toString()``` method.
 *
 * For example: ```Thu Feb 01 2024 00:00:00 GMT-0600 (Central Standard Time)```
 */
export const JS_DATE_TO_STRING_FORMAT = "iii LLL dd yyyy hh:mm:ss 'GMT'xx (zzzz)";

/**
 * The default datetime format to use within the app
 */
export const DATETIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;

/**
 * A datetime format used to make working with and parsing certain dates easier
 * for our `CustomDatePipe` and `DateService` classes.
 */
export const ALT_DATETIME_FORMAT = 'yyyy-MM-dd HH:mm:ss';

/**
 * The date format to be used by census dashboard where date is combined with String
 */
export const CENSUS_DASH_DATE_FORMAT = 'yyyy-MM-dd';

export const ISO8601_DATE_FORMAT = 'yyyy-MM-dd';

export const FILENAME_DATE_FORMAT = 'yyyyMMdd_HHmmss';
